import React from 'react'
import Layout from '@components/Layout'
import { graphql } from 'gatsby'
import config from '@config'
import ArticleContent from '@components/articleContent'
import { filterSampleEntries } from '@utils'

const Article = ({ data, location }) => {
  const relatedArticles = filterSampleEntries(data?.relatedArticles?.nodes)
  const articleUI = data?.articleUi || {}

  const image =
    articleUI?.ogImage?.file?.url || articleUI?.featuredHero?.file?.url
  const title = articleUI?.metaTitle || articleUI?.title
  const description =
    articleUI?.metaDescription || articleUI?.description?.description

  return (
    <Layout
      config={config}
      preview={false}
      location={location}
      ogImage={image}
      metaTitle={title}
      metaDescription={description}
    >
      <ArticleContent {...articleUI} relatedArticles={relatedArticles} />
    </Layout>
  )
}

export default Article

export const query = graphql`
  query Article($contentfulId: String!, $category: String!) {
    articleUi: contentfulArticle(contentful_id: { eq: $contentfulId }) {
      ...baseArticle
    }
    relatedArticles: allContentfulArticle(
      filter: {
        category: { eq: $category }
        contentful_id: { ne: $contentfulId }
      }
      limit: 6
    ) {
      nodes {
        ...baseArticle
      }
    }
  }
`
